import React from 'react';

import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

import {
  CAMERA_FLOW_DEFAULT,
  CAMERA_FLOW_DYNAMSOFT,
  CAMERA_FLOW_GENIUS_SCAN
} from 'utils/constants';

import styles from './styles.module.scss';

const CameraFlowSwitch = ({ cameraFlow, handleChange }) => {
  return (
    <div className={styles.buttonContainer}>
      <FormControl className={styles.options}>
        <InputLabel id="camera-flow-select-label">
          Select Camera Flow
        </InputLabel>
        <Select
          labelId="camera-flow-select-label"
          value={cameraFlow}
          onChange={handleChange}
          label="Camera Flow"
        >
          <MenuItem value={CAMERA_FLOW_DEFAULT}>Default Camera Flow</MenuItem>
          <MenuItem value={CAMERA_FLOW_GENIUS_SCAN}>GeniusScan Flow</MenuItem>
          <MenuItem value={CAMERA_FLOW_DYNAMSOFT}>Dynamsoft Flow</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

export default CameraFlowSwitch;
